module.exports = __webpack_public_path__ + "img/4words_title@2x.6658a8e5.png";